<section class="profile-header">
  <a class="profile-main" [routerLink]="['/next/me/about']">
    @if (account.profile_photo_id) {
      <div class="profile-photo" [ngStyle]="profilePhotoStyle"></div>
    } @else {
      <div class="profile-photo empty">
        <i class="nc-icon nc-camera i-6"></i>
      </div>
    }
    <div class="profile-name">{{ account.username }}</div>
    @if (account.verified) {
      <sb-icon class="ml-1 color-verified" [name]="'verify'" [secondaryColor]="'white'" [size]="'4'" />
    }
    <div class="edit-profile-button-wrapper">
      @if (account.completion_percentage === 100) {
        <button
          class="hover:color-ash"
          sbButton
          [iconOnly]="true"
          [shadow]="'default-sm'"
          [size]="'small'"
          [variant]="'fill-light'"
        >
          <sb-icon [name]="'edit'" [size]="'8'" />
        </button>
      }
    </div>
  </a>
  @if (account.completion_percentage < 100) {
    <div class="profile-completion">
      <div class="completion-progress">
        <div class="progress-bar">
          <div class="progress" [style.width]="`${account.completion_percentage}%`"></div>
        </div>
        <a
          class="hover:color-ash"
          sbButton
          [iconOnly]="true"
          [routerLink]="['/next/me/about']"
          [shadow]="'default-sm'"
          [size]="'small'"
          [variant]="'fill-light'"
        >
          <sb-icon [name]="'edit'" [size]="'8'" />
        </a>
      </div>
      <div class="progress-description">Profile: {{ account.completion_percentage }}%</div>
    </div>
  }
</section>

@if (account.benefactor) {
  <section class="credits-section">
    <div class="balance">
      <i class="nc-icon nc-credits"></i>
      <span class="amount" data-cy="tokenBalanceProfile">
        {{ balance }}
        <span>Credits</span>
      </span>
    </div>
    <div class="action">
      @if (!account.has_too_many_tokens_to_recharge) {
        <a
          data-cy="buyCreditsBtnProfile"
          sbButton
          sbNavigateToCredits="profile-nav-button"
          [size]="'small'"
          [variant]="'fill-gold'"
          (click)="siteNavContainerComponent.close()"
        >
          Buy Credits
        </a>
      } @else {
        <a
          class="ash-color t-9"
          data-cy="noRecharge"
          sbNavigateToCredits="profile-nav-button"
          (click)="siteNavContainerComponent.close()"
          >Credits</a
        >
      }
    </div>
  </section>
}

@if (account.restricted) {
  <section class="account-limited">
    <h5 class="heading t-5" [ngClass]="account.verification_submitted ? 'orange-color' : 'red-color'">
      <i class="nc-icon nc-alert-circle mr-0 i-7"></i>
      Your account is limited
    </h5>
    <p class="description">
      @if (!account.verification_submitted) {
        <span> We have reviewed your account and require you to verify your profile. </span>
      } @else {
        <span>
          We are currently reviewing your verification submission. Your account will be limited until the verification
          is approved.
        </span>
      }
    </p>
    @if (!account.verification_submitted) {
      <div class="actions">
        <a sbButton [variant]="'fill-verified'" (click)="openLimited()">Get Verified</a>
        <a class="t-10 align-right ash-color mr-0 why" (click)="openWhyVerify()">Why?</a>
      </div>
    }
  </section>
}

<nav class="menu">
  @if (isMobile) {
    <ul class="list-unstyled menu-primary hide-above-tablet">
      @if (memberService.showGetVerified()) {
        <li>
          <a
            class="get-verified-link"
            [routerLink]="['/next/me/verifications']"
            (click)="siteNavContainerComponent.close()"
          >
            <button
              class="display-inline-block mr-4"
              sbButton
              [iconOnly]="true"
              [shadow]="'default-sm'"
              [variant]="'fill-light'"
            >
              <sb-icon class="color-verified" [name]="'verify'" [secondaryColor]="'white'" [size]="'6'" />
            </button>
            <span class="color-verified font-weight-500">Get Verified</span>
          </a>
        </li>
      }

      @if (account.benefactor) {
        <li>
          <a [routerLink]="['/next/search']">
            <button
              class="display-inline-block mr-4 hover:color-ash"
              sbButton
              [iconOnly]="true"
              [shadow]="'default-sm'"
              [variant]="'fill-light'"
            >
              <sb-icon [name]="'search'" [size]="'7'" />
            </button>
            Search
          </a>
        </li>
      }
      <li>
        <a [routerLink]="['/next/messages']">
          <button
            class="display-inline-block mr-4 hover:color-ash"
            sbButton
            [iconOnly]="true"
            [shadow]="'default-sm'"
            [variant]="'fill-light'"
          >
            <sb-icon
              [class.color-blue]="messagesDot"
              [name]="'message-bubble'"
              [secondaryColor]="'transparent'"
              [size]="'7'"
            />
            <div class="badge-wrapper">
              @if (messagesDot) {
                <sb-icon class="sa-nav-badge notification-color" [name]="'circle'" [size]="'5'" />
              }
            </div>
          </button>
          Messages
        </a>
      </li>

      @if (siteStore.features().private_content) {
        <li>
          <a [routerLink]="['/next/access/secret-access']">
            <button
              class="display-inline-block mr-4 hover:color-ash"
              sbButton
              [iconOnly]="true"
              [shadow]="'default-sm'"
              [variant]="'fill-light'"
            >
              <sb-icon [class.color-gold]="accessDot" [name]="'key'" [size]="'7'" />
              <div class="badge-wrapper">
                @if (accessDot) {
                  <sb-icon class="sa-nav-badge notification-color" [name]="'circle'" [size]="'5'" />
                }
              </div>
            </button>
            Access
          </a>
        </li>
      }
      <li></li>

      <li>
        <a [routerLink]="['/next/matches/incoming']">
          <button
            class="display-inline-block mr-4 hover:color-ash"
            sbButton
            [iconOnly]="true"
            [shadow]="'default-sm'"
            [variant]="'fill-light'"
          >
            <sb-icon [class.color-salmon]="matchesDot" [name]="matchesDot ? 'heart' : 'heart-o'" [size]="'7'" />
            <div class="badge-wrapper">
              @if (matchesDot) {
                <sb-icon class="sa-nav-badge notification-color" [name]="'circle'" [size]="'5'" />
              }
            </div>
          </button>
          Matches
        </a>
      </li>
      @if (account.dependent) {
        <li>
          <a [routerLink]="['/next/search']">
            <button
              class="display-inline-block mr-4 hover:color-ash"
              sbButton
              [iconOnly]="true"
              [shadow]="'default-sm'"
              [variant]="'fill-light'"
            >
              <sb-icon [name]="'search'" [size]="'7'" />
            </button>
            Search
          </a>
        </li>
      }
      <li>
        <a
          data-cy="navigationProfileMobile"
          [routerLink]="['/next/me/about']"
          (click)="siteNavContainerComponent.close()"
        >
          <button
            class="display-inline-block mr-4 hover:color-ash"
            sbButton
            [iconOnly]="true"
            [shadow]="'default-sm'"
            [variant]="'fill-light'"
          >
            <sb-icon [name]="'user-o'" [size]="'7'" />
          </button>
          Profile
        </a>
      </li>
    </ul>
  }

  <ul class="list-unstyled menu-secondary">
    @if (!isMobile && memberService.showGetVerified()) {
      <li class="hide-below-tablet">
        <a class="get-verified-link" [routerLink]="['/next/me/verifications']">
          <span class="color-verified font-weight-500">Get Verified</span>
          <sb-icon class="ml-1 color-verified" [name]="'verify'" [secondaryColor]="'white'" [size]="'6'" />
        </a>
      </li>
    }

    @if (siteStore.features().affiliate_program) {
      <li>
        <a
          class="color-content-success"
          [routerLink]="['/next/referral-program']"
          (click)="siteNavContainerComponent.close()"
        >
          Earn Money
        </a>
      </li>
    }

    <li>
      <a data-cy="profileNavSettings" [routerLink]="['/next/settings']" (click)="siteNavContainerComponent.close()">
        <span class="text">Settings</span>
      </a>
    </li>
    <li>
      <a data-cy="profileNavHelp" [routerLink]="['/next/help']" (click)="siteNavContainerComponent.close()">
        <span class="text">Help</span>
      </a>
    </li>
    @if (memberService.SA.Constants.sugar) {
      <li>
        <a [routerLink]="['/next/blog']" (click)="siteNavContainerComponent.close()">
          <span class="text">Blog</span>
        </a>
      </li>
    }
    <li>
      <a class="ash-color" [class.disabled]="busy" (click)="logout($event)">
        <span class="text">Logout</span>
      </a>
    </li>
  </ul>
</nav>

<footer class="footer">
  <img class="mr-8" height="12" width="140" [alt]="account.site.name" [src]="'logo-mobile-gray.svg' | assetUrl" />

  <ul class="list-unstyled">
    <li><a [routerLink]="['/next/dating-safety']">Safety</a></li>
    <li><a [routerLink]="['/next/help', 'how-do-i-report-a-member']">Report</a></li>
    <li><a [routerLink]="['/next/terms']">Terms</a></li>
    <li><a [routerLink]="['/next/privacy']">Privacy</a></li>
  </ul>
</footer>
